<script>
import { mapActions } from 'vuex'
import { ACMF_REPORT_DETAILS_CONSTS as ARVC } from '@/stores/consts'

export default {
  methods: {
    ...mapActions(ARVC.NAMESPACE, [
      ARVC.GET_AIRCRAFT_DETAILS,
      ARVC.GET_REPORT_DATA,
      ARVC.GET_NEXT_REPORT_ID,
      ARVC.GET_PREVIOUS_REPORT_ID,
      ARVC.GET_REPORT_TIMELINES_DATA,
      ARVC.GET_GRAPH_GROUPS_PER_REPORT_TYPE,
      ARVC.GET_REPORT_PLOT_GROUPS,
      ARVC.GET_REPORT_PLOT,
    ]),

    navToReportRoute(reportId, tailNumber) {
      this.$router.push({
        name: 'Report Details',
        params: {
          reportId: reportId,
          tailNumber: tailNumber,
        },
      })
    },

    navToReport(reportId, tailNumber) {
      this.$router.push({
        name: 'Report Details',
        params: {
          reportId: reportId,
          tailNumber: tailNumber,
        },
      })
      this.refreshReportData(reportId, tailNumber)
    },

    async refreshReportData(reportId, tailNumber) {
      const params = {
        reportId: reportId,
        tailNumber: tailNumber,
      }
      await Promise.all([
        this[ARVC.GET_REPORT_DATA](params),
        this[ARVC.GET_AIRCRAFT_DETAILS](tailNumber),
        this[ARVC.GET_NEXT_REPORT_ID]({
          currentReportId: reportId,
          ascending: true,
        }),
        this[ARVC.GET_NEXT_REPORT_ID]({
          currentReportId: reportId,
          ascending: false,
        }),
        this[ARVC.GET_REPORT_TIMELINES_DATA]({
          currentReportId: reportId,
          recordCountBefore: 15,
          recordCountAtAndAfter: 15,
        }),
        this[ARVC.GET_GRAPH_GROUPS_PER_REPORT_TYPE](),
      ])
    },
  },
}
</script>
